import $ from 'jquery';

const $map = $('.js-map');

$map.each(function (index, element) {
  let icon = element.dataset.icon;
  let lat = Number(element.dataset.lat);
  let lng = Number(element.dataset.lng);
  let pos = { lat: lat, lng: lng };

  // Create a Google Map embed based off the `data-` attributes of the element.
  let map = new google.maps.Map(element, {
    center: pos,
    zoom: 15,
    scrollwheel: false,
    draggable: false,
    styles: [
      {
        featureType: 'administrative',
        elementType: 'all',
        stylers: [{ saturation: '-100' }],
      },
      {
        featureType: 'administrative.province',
        elementType: 'all',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [
          { saturation: -100 },
          { lightness: 65 },
          { visibility: 'on' },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [
          { saturation: -100 },
          { lightness: '50' },
          { visibility: 'simplified' },
        ],
      },
      {
        featureType: 'road',
        elementType: 'all',
        stylers: [{ saturation: '-100' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'all',
        stylers: [{ visibility: 'simplified' }],
      },
      {
        featureType: 'road.arterial',
        elementType: 'all',
        stylers: [{ lightness: '30' }],
      },
      {
        featureType: 'road.local',
        elementType: 'all',
        stylers: [{ lightness: '40' }],
      },
      {
        featureType: 'transit',
        elementType: 'all',
        stylers: [{ saturation: -100 }, { visibility: 'simplified' }],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ hue: '#ffff00' }, { lightness: -25 }, { saturation: -97 }],
      },
      {
        featureType: 'water',
        elementType: 'labels',
        stylers: [{ lightness: -25 }, { saturation: -100 }],
      },
    ],
  });

  if (icon) {
    // Create and display a marker based off the `data-` attributes of the element.
    let marker = new google.maps.Marker({
      position: pos,
      map: map,
      icon: icon,
    });
  }
});
